<template>
  <div class="p-8">
    <form @submit.prevent="edit">
      <div class="flex pt-4 border-t">
        <div class="w-1/3">
          <h3 class="font-semibold uppercase text-gray-600 text-xl">
            Edit Account
          </h3>
          <p class="text-gray-600">{{ id }}</p>
        </div>
        <div class="w-2/3">
          <div class="flex space-x-4 mt-4">
            <label class="block w-1/2">
              <span class="text-gray-700">First Name</span>
              <input
                v-model="account.firstName"
                class="form-input block w-full"
                placeholder="Abbay"
              />
            </label>
            <label class="block w-1/2">
              <span class="text-gray-700">
                Last Name
              </span>
              <input
                v-model="account.lastName"
                class="form-input block w-full"
                placeholder="Kassa"
              />
            </label>
            <label v-if="!account.roles.includes(4)" class="block w-1/2">
              <div class="text-gray-700">
                Role
              </div>
              <label for="admin" class="mr-3">
                <input
                  type="checkbox"
                  name="admin"
                  :value="1"
                  v-model="account.roles"
                  id="admin"
                  class="mr-2"
                />
                <span>Admin</span>
              </label>
              <label for="dispatcher" class="mr-3">
                <input
                  type="checkbox"
                  name="dispatcher"
                  :value="2"
                  v-model="account.roles"
                  id="dispatcher"
                  class="mr-2"
                />
                <span>Dispatcher</span>
              </label>
              <label for="finance">
                <input
                  type="checkbox"
                  name="finance"
                  :value="3"
                  v-model="account.roles"
                  id="finance"
                  class="mr-2"
                />
                <span>Finance</span>
              </label>
            </label>
          </div>
          <div class="flex space-x-4 mt-4">
            <label class="block w-1/2">
              <span class="text-gray-700">
                Email
              </span>
              <input
                v-model="account.email"
                class="form-input block w-full"
                type="email"
                placeholder="contact@sheraton.com"
              />
            </label>
          </div>
          <div class="mt-4">
            <button
              :disabled="busy"
              class="w-32 py-2 text-ilift-900 rounded shadow"
              :class="
                busy
                  ? 'bg-ilift-200 cursor-not-allowed'
                  : 'bg-ilift-500 hover:bg-ilift-600'
              "
            >
              Update
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      busy: false,
      vehicleTypes: [],
      account: {
        firstName: "",
        lastName: "",
        email: "",
        active: null,
        roles: []
      }
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  created() {
    this.$http
      .get(`/accounts/${this.id}`)
      .then(response => (this.account = response.data))
      .catch(err => console.log(err));
  },
  methods: {
    edit() {
      if (
        this.account.firstName != "" &&
        this.account.lastName != "" &&
        this.account.email != "" &&
        this.account.roles.length
      ) {
        this.busy = true;
        this.$http
          .patch(`accounts/${this.id}`, this.account)
          .then(() => {
            window.flash({
              body: "Account updated successfully!",
              type: "success"
            });
            this.$router.push("/accounts");
          })
          .catch(err => {
            window.flash({ body: "Failed to edit account!", type: "error" });
            console.log(err);
          })
          .finally(() => (this.busy = false));
      }
    }
  }
};
</script>
